import type { ReactNode } from "react";

export function EmptyState({
  title,
  description,
  action,
  icon,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-[var(--border)] bg-[var(--surface)] px-6 py-12 text-center">
      {icon && <div className="text-[var(--fg-muted)]">{icon}</div>}
      <h3 className="text-sm font-medium text-[var(--fg)]">{title}</h3>
      {description && (
        <p className="max-w-sm text-xs text-[var(--fg-muted)]">{description}</p>
      )}
      {action}
    </div>
  );
}
